export const color = {
    white: '#fff',
    whiteGray: '#f2f2f2',
    black: '#000',
    primary1: '#006295',
    primary2: '#00233b',
    primary3: '#06aaee',
    lightGrey: '#EBECF0',
    lightGrey2: '#dadada',
    lightGrey3: '#eee',
    softGrey: '#ddd',
    hardGrey: '#aaa',
    breadcrumbBg: '#f5f5f5',
    breadcrumbActiveColor: '#777',
    breadcrumbColor: '#ccc',
    darkBlue: '#05233f',
    tooltipColor: '#00233b',
    grayDark: '#333',
    lightBlue: '#337ab7',
    facetsBg: '#00355d',
    highLightBlue: '#5897fb',
    silver: '#C3C3C3',
    darkGrey2: '#60829D',
    darkGrey3: '#6d8fa9',
    lightGrey4: '#a2b8c9',
};

export const font = {
    standard: '12px',
    size11: '0.91rem',
    size12: '12px',
    size13: '1.1rem',
    size14: '1.166rem',
    size15: '1.25rem',
    size16: '1.333rem',
    size17: '1.4rem',
    size18: '1.5rem',
    size20: '1.667rem',
    size22: '1.833rem',
    size23: '1.9rem',
    size24: '2rem',
    size25: '2.0833rem',
    size26: '2.167rem',
    size28: '2.4rem',
    size30: '2.5rem',
    size32: '2.666rem',
    size34: '2.91rem',
    size40: '3.4rem',
    size48: '4rem',
    size52: '4.8rem',
};

export const screenSize = {
    xs: '480px',
    sm: '768px',
    smMax: '992px',
    md: '993px',
    lg: '1200px',
};
